<div class="white-bg no-padding no-margin">
  <!-- <breadcrumbs>
    <breadcrumb route="/" label="Dashboard"></breadcrumb>
    <breadcrumb [currentRoute]="true" label="Setup Training Types and Section"></breadcrumb>
  </breadcrumbs> -->
  <mat-card>
    <div style="text-align: center;">
      <span class="title-header">{{'Training' | translate | async}}</span>
    </div>
    <div style="padding: 2%;">
      <span style="font-size: larger; "><b>{{'Filter by Topic' | translate | async}}</b></span>
      <mat-select placeholder="{{'All Topics' | translate | async}}" style="width: 345px; margin-left: 2%; margin-right: 6%;"
        [(ngModel)]="SubCatId">
        <mat-option value="0" (click)="SubCatSelect(null)">{{'All Topics' | translate | async}}</mat-option>
        <mat-optgroup *ngFor="let group of TraingCatList" [label]="group.Name">
          <mat-option *ngFor="let sub of group.SubCatList" [value]="sub.Id" (click)="SubCatSelect(sub)">
            {{sub.Name}}
          </mat-option>
        </mat-optgroup>
      </mat-select>
      <div style="display: none;">
         <ng-container *ngIf="isAdmin==true">
        <span style="font-size: larger; "><b>{{'Filter by User' | translate | async}}</b></span>
        <mat-select placeholder="Select User" style="width: 345px; margin-left: 2%;" [(ngModel)]="UserId">
          <mat-option value="0" (click)="SelectUser()">Select User</mat-option>
          <mat-option *ngFor="let user of UserList" [value]="user.Id" (click)="SelectUser()">
            {{user.Name | aesDecrypt}}
          </mat-option>
        </mat-select>
      </ng-container>
      </div>
    </div>
     <div class="center" *ngIf="loading">
      <mat-spinner></mat-spinner>
    </div>
    <div class="training-body" *ngIf="!loading">
      <div class="left-panel">
        <ng-container *ngFor="let fcm of trainingMainCategories">
          <mat-expansion-panel class="parametersPanel" [expanded]="true">
            <mat-expansion-panel-header style="background: #c7c7c7;">
              <div class="panel__header" style="display: flex;flex: 1;;justify-content: space-between;">
                <span class="panel__header__title" style="font-size: larger;">
                  <b>{{fcm.TrainigCatName | translate | async}}</b>
                </span>
              </div>
            </mat-expansion-panel-header>
            <div>
              <ng-container *ngFor="let fc of trainingCategories">
                <mat-expansion-panel class="parametersPanel" [expanded]="true"
                  *ngIf=" fc.MainParentId && fc.MainParentId == fcm.TrainigCatId">
                  <mat-expansion-panel-header style="background: #E0E0E0;">
                    <div class="panel__header" style="display: flex;flex: 1;;justify-content: space-between;">
                      <span class="panel__header__title" style="font-size: larger;margin-left: 1%">
                        <b>{{fc.TrainigCatName | translate | async}}</b>
                      </span>

                    </div>
                  </mat-expansion-panel-header>
                  <div>
                    <ng-container *ngFor="let fs of trainingSections">
                      <mat-expansion-panel class="parametersPanel" [expanded]="fs.isExpanded" (click)="togglePanel(fs)"
                        *ngIf=" fs.ParentCatId && fs.ParentCatId == fc.TrainigCatId">
                        <mat-expansion-panel-header style="background: #E8E8E8;">
                          <div class="panel__header"
                            style="display: flex; flex-direction: row; justify-content: space-between; flex: 1;">
                            <div style="width: 80%;">
                              <span class="panel__header__title"
                                style="font-size: medium; font-style: italic; margin-left: 2%">
                                <b>{{fs.TrainigCatName | translate | async}}</b>
                              </span>
                            </div>
                          </div>
                        </mat-expansion-panel-header>
                        <div>
                          <ng-container *ngFor="let f of trainings">
                            <ng-container *ngIf=" fs.TrainigCatId == f.TrainingTypeId">
                              <div style="display: flex;border-bottom: inset; padding: 1%;">
                                <div class="panel__header"
                                  style="display: flex; flex-direction: row; justify-content: space-between; flex: 1; margin-right: 4%; margin-left: 1%">
                                  <div style="display: flex; width: 90%;cursor: pointer; ">
                                    <a>
                                      <i *ngIf="isAdmin==true" class="material-icons button__icon"
                                        style="font-size: 28px;margin-right: 20px; color:limegreen;vertical-align: middle; cursor: pointer;"
                                        (click)="ForwardEmail(f.TrainingId)">forward_to_inbox</i>
                                    </a>
                                    <div style="display: flex; flex-direction: column;"
                                      (click)="StartTraining(f.Status,f.TrainingId,f.SessionId)">
                                      <span class="panel__header__title">
                                        {{f.TrainingName | translate | async}}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div style="width: 20%">
                                  <i *ngIf="f.Status==0 && f.IsVideoUrl" class="material-icons button__icon"
                                    style="font-size: 28px;margin-right: 20px;vertical-align: middle; cursor: pointer;"
                                    (click)="StartTraining(0,f.TrainingId,f.SessionId, f.TrainingTypeId)"
                                    title="Not Started">trip_origin</i>
                                  <i *ngIf="f.Status==1 && f.IsVideoUrl" class="material-icons button__icon"
                                    style="font-size: 28px;margin-right: 20px;color: orange;vertical-align: middle; cursor: pointer;"
                                    (click)="StartTraining(1,f.TrainingId,f.SessionId, f.TrainingTypeId)"
                                    title="In Progress">trip_origin</i>
                                  <i *ngIf="f.Status==2 && f.IsVideoUrl" class="material-icons button__icon"
                                    style="font-size: 28px;margin-right: 20px; color:limegreen;vertical-align: middle; cursor: pointer;"
                                    (click)="StartTraining(2,f.TrainingId,0, f.TrainingTypeId)"
                                    title="Completed">check_circle_outline</i>
                                  <i *ngIf="!f.IsVideoUrl" class="material-icons button__icon"
                                    style="font-size: 28px;margin-right: 20px; color:grey;vertical-align: middle; cursor: pointer;"
                                    (click)="StartTraining(0,f.TrainingId,f.SessionId, f.TrainingTypeId)"
                                    title="No Video Available">trip_origin</i>
                                </div>
                              </div>
                            </ng-container>
                          </ng-container>
                        </div>
                      </mat-expansion-panel>
                    </ng-container>
                  </div>
                </mat-expansion-panel>
              </ng-container>
            </div>
          </mat-expansion-panel>
        </ng-container>
      </div>
      <!-- RIGHT SIDE -->
      <div class="right-panel">
        <!-- CONTROLS HEADER -->
        <div class="video-header" *ngIf="showNavigation">
          <div class="nav-left">
            <span>NAVIGATION:</span>
            <button (click)="playVideo()">▶ Start</button>
            <button class="pause-btn" (click)="pauseVideo()">⏸ Stop</button>
          </div>
          <div class="nav-center">
            {{ sectionName }}
          </div>
          <div class="nav-right">
            <button *ngIf="TrainingQuestions_?.length > 0" (click)="quizSection()">Quiz Section</button>
            <button (click)="nextSection(this.NextTrainingId)">Next Section ⏭</button>
            <button title="Close Video" (click)="closeVideo()">✖</button>
          </div>
        </div>
        <div class="content-wrapper" *ngIf="!isSectionQView && !trainingStart">
          <!-- SLIDES / IMAGE VIEW -->
          <ng-container *ngIf="currentVideoUrl">
            <!-- IMAGE -->
            <div *ngIf="!isURL && !noVideo" class="media-container">
              <img [src]="sanitize(selectedSlide)" />
            </div>
            <div *ngIf="noVideo">
              No Data Available
            </div>
            <!-- YOUTUBE -->
            <div *ngIf="isURL && !noVideo " class="media-container">
              <iframe #youtubePlayer [src]="safeYoutubeUrl" frameborder="0" allow="autoplay; encrypted-media"
                allowfullscreen (load)="onIframeLoad()">
              </iframe>
            </div>
          </ng-container>
          <!-- PLACEHOLDER -->
          <div class="video-wrapper" *ngIf="!currentVideoUrl && !noVideo">
            <div class="video-placeholder">
              <div class="placeholder-content">
                <div class="play-icon"></div>
                <h2>Select a video to start</h2>
                <p>Choose a training module from the sidebar</p>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!currentVideoUrl && isSectionQView" class="main-wrapper">
          <div class="content-container">
            <!-- HEADER -->
            <div class="header">
              <h2>Training Questions</h2>
            </div>
            <!-- QUESTIONS -->
              <ng-container *ngFor="let q of TrainingQuestions">
                <div style="margin-top: 20px;">
                  <!-- Question Title -->
                  <div style="display: flex; align-items: center;">
                    <a>
                      <i *ngIf="q.Invalid==true" class="material-icons"
                        style="font-size: 28px; margin-right: 15px; color:red; cursor: pointer;"
                        (click)="GotoReleventSlide(q.TrainingId)">
                        report_problem
                      </i>
                    </a>
                    <span style="font-weight: 600;">
                      {{q.Order+1}}.) {{q.QuestionName}}
                    </span>
                  </div>
                  <!-- RADIO BUTTON QUESTIONS -->
                  <ng-container *ngIf="q.QuestionTypeId==2 || q.QuestionTypeId==1">
                    <div style="margin-top: 8px; margin-left: 40px;">
                      <mat-radio-group aria-label="Select Slide Type" id="ans_{{q.QuestionId}}"
                        style="display: flex; flex-direction: column;">
                        <mat-radio-button *ngFor="let option of q.AnswerList" [value]="option.Id"
                          (click)="SelectAnswerRadio(option,q)">
                          {{option.Name}}
                          <span>
                            <i *ngIf="option.Select==true && q.Invalid==true" class="material-icons"
                              style="font-size: 20px; margin-left: 10px; color:#1db330de;">
                              verified
                            </i>
                          </span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </ng-container>
                  <!-- MULTIPLE SELECTION QUESTIONS -->
                  <ng-container *ngIf="q.QuestionTypeId==3">
                    <div style="margin-top: 8px; margin-left: 40px;">
                      <mat-list-item *ngFor="let item of q.AnswerList" id="ans_{{q.QuestionId}}">
                        <mat-checkbox (change)="SelectAnswerMutipleSelection(q,item)" [value]="item.Id">
                          {{ item.Name }}
                          <span>
                            <i *ngIf="item.Select==true && q.Invalid==true" class="material-icons"
                              style="font-size: 20px; margin-left: 10px; color:#1db330de;">
                              verified
                            </i>
                          </span>
                        </mat-checkbox><br>
                      </mat-list-item>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            <!-- SUBMIT BUTTON -->
            <div *ngIf="!gotoNextSection" style="width:100%; display:flex; justify-content:center; margin-top:30px;">
              <a class="button button--primary" (click)="submitAnswers()">
                <span class="button__text">Submit</span>
              </a>
            </div>
            <!-- DONE BUTTON -->
            <div *ngIf="FinishTrainig" style="width:100%; display:flex; justify-content:center; margin-top:30px;">
              <a class="button button--primary" (click)="finishTraining()">
                <span class="button__text">Done</span>
              </a>
            </div>
            <!-- INVALID MESSAGE -->
            <div *ngIf="hasInvalidQ && !questionsAnsweredCorrectly"
              style="background-color: lightgrey; margin-top:20px; padding:15px; text-align:center;">
              <label style="font-size: large;">
                You did not get all questions correct. Please use the
                <i class="material-icons" style="color:red;">report_problem</i>
                to review the relevant slide then return to these questions to amend your answer.
              </label>
            </div>
            <div *ngIf="questionsAnsweredCorrectly && !hasInvalidQ"
              style="background-color: lightgrey; margin-top:20px; padding:15px; text-align:center;">
              <label style="font-size: large; color: green;">
                All questions have been answered correctly.
              </label>
            </div>
          </div>
        </div>
        <div *ngIf="trainingStart">
          <div class="white-bg no-padding no-margin">
            <mat-card>
              <div style="text-align: center; margin-top: 1%;">
                <span class="title-header">Training </span>
              </div>
              <div
                style="text-align: center;margin-top: 1%;display: flex; flex-direction: column; font-size: x-large;font-weight: bolder;font-size: 28px;padding: 3%;">
                <span class="title-header" style="height: 50px;">Hello {{username | aesDecrypt}} </span>
                <span class="title-header"> </span>
                <span class="title-Subheader">Click Start to begin </span>
                <span class="title-header">{{training}} </span>
              </div>
              <div style="width: 100%;   display: flex;flex-direction: row;justify-content:center;">
                <a class="button button--primary" (click)="startTraining()">
                  <span class="button__text">Start</span></a>
              </div>
            </mat-card>
          </div>
        </div>
      </div>
      <!-- <ng-container *ngFor="let fc of trainingCategories">
      <mat-expansion-panel class="parametersPanel" [expanded]="true">
        <mat-expansion-panel-header style="background: #E0E0E0;">
          <div class="panel__header" style="display: flex;flex: 1;;justify-content: space-between;">
            <span class="panel__header__title" style="font-size: larger;">
              <b>{{fc.TrainigCatName | translate | async}}</b>
            </span>

          </div>
        </mat-expansion-panel-header>
        <div>
          <ng-container *ngFor="let fs of trainingSections">
            <mat-expansion-panel class="parametersPanel" *ngIf=" fs.ParentCatId && fs.ParentCatId == fc.TrainigCatId">
              <mat-expansion-panel-header style="background: #E8E8E8;">
                <div class="panel__header"
                  style="display: flex; flex-direction: row; justify-content: space-between; flex: 1;">
                  <div style="width: 80%;">
                    <span class="panel__header__title" style="font-size: medium; font-style: italic; margin-left: 1%">
                      <b>{{fs.TrainigCatName | translate | async}}</b>

                    </span>
                  </div>
                </div>

              </mat-expansion-panel-header>
              <div>
                <ng-container *ngFor="let f of trainings">
                  <ng-container  *ngIf=" fs.TrainigCatId == f.TrainingTypeId">
                    <div style="    display: flex;border-bottom: inset;
                    padding: 1%;">
                      <div class="panel__header"
                          style="display: flex; flex-direction: row; justify-content: space-between; flex: 1; margin-right: 4%; margin-left: 1%">
                          <div style="display: flex; width: 90%;cursor: pointer; ">
                            <a>

                              <i *ngIf="isAdmin==true" class="material-icons button__icon"
                                style="font-size: 28px;margin-right: 20px; color:limegreen;vertical-align: middle; cursor: pointer;"
                                (click)="ForwardEmail(f.TrainingId)">forward_to_inbox</i>
                            </a>

                            <div style="display: flex; flex-direction: column;" (click)="StartTraining(f.Status,f.TrainingId,f.SessionId)">

                              <span class="panel__header__title" > 
                                {{f.TrainingName | translate | async}}
                              </span>
                           
                            </div>
                          </div>
                        </div>
                        <div style="width: 20%">
                          <i *ngIf="f.Status==0 " class="material-icons button__icon"
                            style="font-size: 28px;margin-right: 20px;vertical-align: middle; cursor: pointer;" (click)="StartTraining(0,f.TrainingId,f.SessionId)" title="Not Started">trip_origin</i>
                          <i *ngIf="f.Status==1" class="material-icons button__icon"
                            style="font-size: 28px;margin-right: 20px;color: orange;vertical-align: middle; cursor: pointer;" (click)="StartTraining(1,f.TrainingId,f.SessionId)" title="In Progress">trip_origin</i>
                          <i *ngIf="f.Status==2" class="material-icons button__icon"
                            style="font-size: 28px;margin-right: 20px; color:limegreen;vertical-align: middle; cursor: pointer;" (click)="StartTraining(2,f.TrainingId,0)" title="Completed">check_circle_outline</i>

                        </div>
                      </div>
                      

                  </ng-container>
                  
                </ng-container>
              </div>
            </mat-expansion-panel>
          </ng-container>
        </div>
      </mat-expansion-panel>
    </ng-container> -->
    </div>
  </mat-card>
</div>